import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { database } from "../firebase";
import profileActions from "../redux/profile/actions";


function EditLinks() {
    const {
        currentUser,
        creditzIds,
        Loading = [],
    } = useSelector((state) => ({
        currentUser: state.profile.currentUser,
        creditzIds: state.profile.creditzIds,
        Loading: state.profile.Loading,
    }));
    const dispatch = useDispatch();
    const [facebooklink, setFacebookLink] = useState(currentUser.facebooklink);
    const [instagramlink, setInstagramLink] = useState(currentUser.instagramlink);
    const [twitterlink, setTwitterLink] = useState(currentUser.twitterlink);
    const [trillerlink, setTrillerlink] = useState(currentUser.trillerlink);
    const [youtubelink, setYoutubeLink] = useState(currentUser.youtubelink);
    const [soundcloudlink, setSoundCloud] = useState(currentUser.soundcloudlink);

    const [linkvalue, setLinkvalue] = useState("");
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [show, setShow] = useState(false);
    const [type, setType] = useState("");
    const [link, setLink] = useState("");
    const [value, setValue] = useState("")
    async function Update() {
        let value = "";
        if (link === "https://www.facebook.com/") {
            value = "facebooklink";
        } else if (link === "https://www.instagram.com/") {
            value = "instagramlink";
        } else if (link === "https://www.twitter.com/") {
            value = "twitterlink";
        }
        else if (link === "https://triller.co/") {
            value = "trillerlink"
        }
        else if (link === "https://soundcloud.com/") {
            value = "soundcloudlink"
        }
        else if (link === "https://soundcloud.com/") {
            value = "soundcloudlink"
        }
        else if (link === "https://www.youtube.com/channel/") {
            value = "youtubelink"
        }
        const updates = {};
        updates[`/users/${currentUser.uid}/${value}`] = link + linkvalue;
        await database.ref().update(updates);
        if (link === "https://www.facebook.com/") {
            setFacebookLink(link + linkvalue);

        } else if (link === "https://www.instagram.com/") {
            setInstagramLink(link + linkvalue);

        } else if (link === "https://www.twitter.com/") {
            setTwitterLink(link + linkvalue);

        }
        else if (link === "https://triller.co/") {
            setTrillerlink(link + linkvalue)
        }
        else if (link === "https://soundcloud.com/") {
            setSoundCloud(link + linkvalue)
        }
        else if (link === "https://www.youtube.com/channel/") {
            setYoutubeLink(link + linkvalue)
        }
        dispatch({
            type: profileActions.GET_CURRENT_USER,
            payload: {
                uid: currentUser.uid
            },
        });
        handleClose()
    }

    function handleDelete(value, link) {
        const updates = {};

        updates[`/users/${currentUser.uid}/${value}`] = "";
        if (value) {
            database.ref().update(updates);

            if (link === "https://www.facebook.com/") {
                setFacebookLink("");

            } else if (link === "https://www.instagram.com/") {
                setInstagramLink("");

            } else if (link === "https://www.twitter.com/") {
                setTwitterLink("");

            }
            else if (link === "https://triller.co/") {
                setTrillerlink("")
            }
            else if (link === "https://soundcloud.com/") {
                setSoundCloud("")
            }

            else if (link === "https://www.youtube.com/channel/") {
                setYoutubeLink("")
            }
        }
        dispatch({
            type: profileActions.GET_CURRENT_USER,
            payload: {
                uid: currentUser.uid
            },
        });
    }
    useEffect(() => {
        if (currentUser.facebooklink) {
            setFacebookLink(currentUser.facebooklink);
        } else {
            setFacebookLink("");
        }

        if (currentUser.instagramlink) {
            setInstagramLink(currentUser.instagramlink);
        } else {
            setInstagramLink("");
        }

        if (currentUser.twitterlink) {
            setTwitterLink(currentUser.twitterlink);
        } else {
            setTwitterLink("");
        }

        if (currentUser.trillerlink) {
            setTrillerlink(currentUser.trillerlink);
        } else {
            setTrillerlink("");
        }
        if(currentUser.youtubelink){
            setYoutubeLink(currentUser.youtubelink)
        }
        else{
            setYoutubeLink("")
        }
        if(currentUser.soundcloudlink){
            setSoundCloud(currentUser.soundcloudlink)
        }
        else{
            setSoundCloud("")
        }
    }, [currentUser]);
    return (
        <>
            <div className="row mb-1">
                <div className="col-md-6">
                    <h5 className="mb-3">Social</h5>
                    <div className="d-flex align-items-center p-3 bg-light rounded-lg mt-2">
                        <img src="./assets/images/social_instagram.jpg" className="mmwh-45 rounded-lg" alt="social" />
                        <span className="ms-3">Instagram</span>
                        {instagramlink === "" ? (
                            <button
                                onClick={() => {
                                    handleShow();
                                    setType("Enter your Instagram URL");
                                    setLink("https://www.instagram.com/");
                                }}
                                className="btn btn-primary fw-medium rounded-pill px-3 ms-auto"
                            >
                                Connect
                            </button>
                        ) : (
                            <button
                                onClick={() => {
                                    handleDelete('instagramlink', "https://www.instagram.com/");
                                }}
                                className="btn btn-secondary rounded-pill fw-semibold px-3 ms-auto"
                            >
                                Remove
                            </button>
                        )}
                    </div>
                    <div className="d-flex align-items-center p-3 bg-light rounded-lg mt-2">
                        <img src="./assets/images/social_twitter.jpg" className="mmwh-45 rounded-lg" alt="social" />
                        <span className="ms-3">Twitter</span>
                        {twitterlink === "" ? (
                            <button
                                onClick={() => {
                                    handleShow();
                                    setType("Enter your Twitter URL");
                                    setLink("https://www.twitter.com/");
                                }}
                                className="btn btn-primary fw-medium rounded-pill px-3 ms-auto"
                            >
                                Connect
                            </button>
                        ) : (
                            <button
                                onClick={() => {

                                    handleDelete('twitterlink', "https://www.twitter.com/");
                                }}
                                className="btn btn-secondary rounded-pill fw-semibold px-3 ms-auto"
                            >
                                Remove
                            </button>
                        )}
                    </div>
                    <div className="d-flex align-items-center p-3 bg-light rounded-lg mt-2">
                        <img src="./assets/images/social_facebook.jpg" className="mmwh-45 rounded-lg" alt="social" />
                        <span className="ms-3">Facebook</span>
                        {facebooklink === "" ? (
                            <button
                                onClick={() => {
                                    handleShow();
                                    setType("Enter your Facebook URL");
                                    setLink("https://www.facebook.com/");

                                }}
                                className="btn btn-primary fw-medium rounded-pill px-3 ms-auto"
                            >
                                Connect
                            </button>
                        ) : (
                            <button
                                onClick={() => {
                                    handleDelete('facebooklink', "https://www.facebook.com/");
                                }}
                                className="btn btn-secondary rounded-pill fw-semibold px-3 ms-auto"
                            >
                                Remove
                            </button>
                        )}
                    </div>
                    <div className="d-flex align-items-center p-3 bg-light rounded-lg mt-2">
                        <img src="./assets/images/social_triller.jpg" className="mmwh-45 border rounded-lg" alt="social" />
                        <span className="ms-3">Triller</span>
                        {trillerlink === "" ? (
                            <button
                                onClick={() => {
                                    handleShow();
                                    setType("Enter your Triller URL");
                                    setLink("https://triller.co/");

                                }}
                                className="btn btn-primary fw-medium rounded-pill px-3 ms-auto"
                            >
                                Connect
                            </button>
                        ) : (
                            <button
                                onClick={() => {

                                    handleDelete('trillerlink', "https://triller.co/");
                                }}
                                className="btn btn-secondary rounded-pill fw-semibold px-3 ms-auto"
                            >
                                Remove
                            </button>
                        )}
                    </div>

                </div>
                <div className="col-md-6">
                    <h5 className="mb-3">Music</h5>
                    {/* <div className="d-flex align-items-center p-3 bg-light rounded-lg mt-2">
                        <img src="./assets/images/music_spotify.jpg" className="mmwh-45 rounded-lg" alt="music" />
                        <span className="ms-3">Spotify</span>
                        <Link to="#" className="btn btn-primary fw-medium ms-auto">Connect</Link>
                    </div> */}
                    {/* <div className="d-flex align-items-center p-3 bg-light rounded-lg mt-2">
                        <img src="./assets/images/music_applemusic.jpg" className="mmwh-45 rounded-lg" alt="music" />
                        <span className="ms-3">Apple Music</span>
                        <Link to="#" className="btn btn-primary fw-medium ms-auto">Connect</Link>
                    </div> */}
                    <div className="d-flex align-items-center p-3 bg-light rounded-lg mt-2">
                        <img src="./assets/images/music_ytmusic.jpg" className="mmwh-45 rounded-lg" alt="music" />
                        <span className="ms-3">YouTube Music</span>
                        {youtubelink === "" ? (
                            <button
                                onClick={() => {
                                    handleShow();
                                    setType("Enter your Youtube Channel URL");
                                    setLink("https://www.youtube.com/channel/");

                                }}
                                className="btn btn-primary fw-medium rounded-pill px-3 ms-auto"
                            >
                                Connect
                            </button>
                        ) : (
                            <button
                                onClick={() => {

                                    handleDelete('youtubelink', "https://www.youtube.com/channel/");
                                }}
                                className="btn btn-secondary rounded-pill fw-semibold px-3 ms-auto"
                            >
                                Remove
                            </button>
                        )}
                    </div>
                    <div className="d-flex align-items-center p-3 bg-light rounded-lg mt-2">
                        <img src="./assets/images/music_soundcloud.jpg" className="mmwh-45 rounded-lg" alt="music" />
                        <span className="ms-3">SoundCloud</span>
                        {soundcloudlink === "" ? (
                            <button
                                onClick={() => {
                                    handleShow();
                                    setType("Enter your SoundCloud URL");
                                    setLink("https://soundcloud.com/");

                                }}
                                className="btn btn-primary fw-medium rounded-pill px-3 ms-auto"
                            >
                                Connect
                            </button>
                        ) : (
                            <button
                                onClick={() => {

                                    handleDelete('soundcloudlink', "https://soundcloud.com/");
                                }}
                                className="btn btn-secondary rounded-pill fw-semibold px-3 ms-auto"
                            >
                                Remove
                            </button>
                        )}
                    </div>
                </div>
                <Modal show={show} onHide={handleClose}>
                    <Modal.Header>
                        <Modal.Title>{type}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div class="input-group mb-3">
                            <div class="input-group-prepend">
                                <span
                                    class="input-group-text"
                                    id="basic-addon3"
                                >
                                    {link}
                                </span>
                            </div>
                            <input
                                type="text"
                                class="form-control"
                                aria-describedby="basic-addon3"
                                value={linkvalue}
                                onChange={(e) => {
                                    setLinkvalue(e.target.value);
                                }}
                            ></input>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            variant="secondary"
                            onClick={handleClose}
                        >
                            Close
                        </Button>
                        <Button variant="primary" onClick={Update}>
                            Save Changes
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        </>
    );
}
export default EditLinks;